import { SitngoCodePanel } from '@/components/hub/panels/SitngoCodePanel';
import { sitngoDiQtournamentsAcceso } from '@/lib/limulo/sitngoAcceso';
import { Tournaments } from '@/routes/Tournaments';

/**
 * Sit&Go — the sit&go list directly (pins the `sitAndGo` view). See EventsPanel.
 *
 * 🔴 A flag acceso i SIT&GO DI qTOURNAMENTS al posto delle liste di QDuels e del monolite (Luca,
 * L-2285, 2026-09-26: «nel pannello «Sit&Go» della Hub CR, con «Entra/Esci» come le code, al posto
 * delle liste di QDuels e del monolite (solo su stg, a flag)»). Il flag e' suo,
 * `VITE_FEATURE_TOURNAMENT_SITNGO_ENABLED`, in AND con quello delle code e con Limulo: il biglietto
 * vive in `CodeTorneiContext`, che monta solo con quei due. A flag spento resta `Tournaments` com'e',
 * e le sue liste non partono nemmeno a flag acceso (non si monta). Il predicato e' UNO
 * (`sitngoDiQtournamentsAcceso`), condiviso con la barra della coda.
 */
export function SitngoPanel() {
  if (sitngoDiQtournamentsAcceso()) return <SitngoCodePanel />;
  return (
    <div className="-mx-4 h-full">
      <Tournaments forcedView="sitAndGo" />
    </div>
  );
}
